export default function ($) {
  const pageHash = window.location.hash;
  if (!pageHash) return;
  if (pageHash.includes('#scroll-to-')) {
    const scrollTarget = pageHash.substr(11);
    const element = document.getElementById(scrollTarget);
    const rect = element.getBoundingClientRect().top;
    if (!element) return;
    setTimeout(() => {
      $('html, body').animate({
        scrollTop: rect,
      }, 1500);
    }, 2000);
  }
}
